import type { ReactElement } from "react";
import ActivitateTargetare from "./pagini/ActivitateTargetare";
import ContacteTargetare from "./pagini/ContacteTargetare";
import FirmeTargetare from "./pagini/FirmeTargetare";
import IncadrareTargetare from "./pagini/IncadrareTargetare";
import ListeTargetare from "./pagini/ListeTargetare";
import MapareTargetare from "./pagini/MapareTargetare";
import MatriceTargetare from "./pagini/MatriceTargetare";
import ReguliTargetare from "./pagini/ReguliTargetare";
import RiscTargetare from "./pagini/RiscTargetare";
import ScoruriTargetare from "./pagini/ScoruriTargetare";
import TinteTargetare from "./pagini/TinteTargetare";

// Cheile trebuie sa corespunda exact id-urilor paginilor GRUP_TARGETARE din
// src/config/administrare.ts (verificat de un test — vezi rutePagini.test.ts). Inlocuieste
// lista separata din App.tsx (D14).
export const PAGINI_TARGETARE: Record<string, ReactElement> = {
  firme: <FirmeTargetare />,
  incadrare: <IncadrareTargetare />,
  risc: <RiscTargetare />,
  contacte: <ContacteTargetare />,
  tinte: <TinteTargetare />,
  activitate: <ActivitateTargetare />,
  matrice: <MatriceTargetare />,
  mapare: <MapareTargetare />,
  liste: <ListeTargetare />,
  scoruri: <ScoruriTargetare />,
  reguli: <ReguliTargetare />,
};
